/**
 * Sightings API Module
 * Handles sighting operations and confirmations
 * Part of API optimization - follows AIM atomicity principle
 */

import { api } from './client'

export const sightingAPI = {
  createSighting: (data, config) => api.post('/sightings', data, config),
  getSighting: (id) => api.get(`/sightings/${id}`),
  updateSighting: (id, data) => api.put(`/sightings/${id}`, data),
  deleteSighting: (id) => api.delete(`/sightings/${id}`),
  getEntitySightings: (entityId) => api.get(`/sightings/entity/${entityId}`),
  getUserSightings: (userId) => api.get(`/sightings/user/${userId}`),
  getUserStats: (userId, params) => api.get(`/sightings/user/${userId}/stats`, { params }),
  confirmSightingWithImage: (id, data, config) => api.post(`/sightings/${id}/confirm`, data, config),
  getPendingConfirmations: (params) => api.get('/sightings/pending-confirmations', { params }),
  getLiveFeed: (params) => api.get('/sightings/live', { params }),
  getSightingPublic: (id) => api.get(`/sightings/${id}/public`),
  getUnenrichedSightings: () => api.get('/sightings/mine/unenriched', { silentError: true }),
  uploadImage: (formData) => api.post('/upload/image', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
